<div class="payment-info-container">
  <!-- Header Section -->
  <div class="payment-profile-header">
    <h2>{{ 'PAYMENT_PAGE.CALL_PAGE_HEADING' | translate }}</h2>
  </div>

  <div class="main-content">
    <div class="row g-3">
      <div class="col-md-4">
        <div class="stat-card">
          <div class="payment-details">
            <h6>{{ 'PAYMENT_PAGE.CARDS_LABELS.CALL_PAYMENTS' | translate }}</h6>
            <p>
              {{ 'PAYMENT_PAGE.CARDS_LABELS.GROSS_REVENUE' | translate }}
              <span
                ><i
                  class="pi pi-info-circle"
                  [pTooltip]="'PAYMENT_PAGE.CARDS_LABELS.REVENUE_TOOLTIP' | translate"
                  tooltipPosition="right"
                  placeholder="Right"
                ></i
              ></span>
            </p>
            <p>{{ 'PAYMENT_PAGE.CARDS_LABELS.TOTAL_REVENUE' | translate }}</p>
            <p>{{ 'PAYMENT_PAGE.CARDS_LABELS.TOTAL_TRANSACTIONS' | translate }}</p>
          </div>
          <div class="payment-other-details">
            <p><i class="pi pi-credit-card card-icon"></i></p>
            <p>
              {{
                paymentStatisticsResponse?.grossRevenue || 0
                  | currency: paymentStatisticsResponse?.totalRevenueCurrency
              }}
            </p>
            <p>
              {{
                paymentStatisticsResponse?.totalRevenueReceived || 0
                  | currency: paymentStatisticsResponse?.totalRevenueCurrency
              }}
            </p>
            <p>
              {{ paymentStatisticsResponse?.totalTransactions || 0 }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="stat-card">
          <div class="payment-details">
            <h6 class="payout-margin">{{ 'PAYMENT_PAGE.CARDS_LABELS.PAYOUTS_TB' | translate }}</h6>
            <p>
              {{ 'PAYMENT_PAGE.CARDS_LABELS.PENDING_PAYMENT' | translate }}
              <span
                ><i
                  class="pi pi-info-circle"
                  [pTooltip]="'PAYMENT_PAGE.CARDS_LABELS.PAYOUT_TOOLTIP' | translate"
                  tooltipPosition="right"
                  placeholder="Right"
                ></i
              ></span>
            </p>
            <p>{{ 'PAYMENT_PAGE.CARDS_LABELS.TOTAL_PAYOUT' | translate }}</p>
          </div>
          <div class="payment-other-details">
            <p class="payout-icon-margin"><i class="pi pi-book card-icon"></i></p>
            <p>
              {{
                paymentStatisticsResponse?.pendingPayoutPayments || 0
                  | currency: paymentStatisticsResponse?.totalPayoutAmountCurrency
              }}
            </p>
            <p>
              {{
                paymentStatisticsResponse?.totalPayoutAmount || 0
                  | currency: paymentStatisticsResponse?.totalPayoutAmountCurrency
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-1">
    <div class="col-md-12">
      <h5 class="payment-head">{{ 'PAYMENT_PAGE.PAYMENT_TABLE_HEADING' | translate }}</h5>
      <p-button
        label="{{ 'PAYMENT_PAGE.BUTTONS.EXPORT' | translate }}"
        icon="pi pi-download"
        class="p-button-primary export-button"
        (click)="exportExcel()"
      ></p-button>
      <p-table
        [value]="paymentItems.length !== 0 ? paymentItems : noDataRow"
        [paginator]="paymentItems.length !== 0 ? true : false"
        [rows]="rows"
        [first]="first"
        [totalRecords]="totalRecords"
        [lazy]="true"
        (onPage)="pageChange($event)"
        (onSort)="sortChange($event)"
        [rowsPerPageOptions]="tableParams.ROW_PER_PAGE"
        sortField="GeneratedOn"
        [sortOrder]="-1"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="InvoiceNumber">
              {{ 'PAYMENT_PAGE.PAYMENT_TABLE.INVOICE_NUMBER' | translate }}
              <p-sortIcon field="InvoiceNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="GeneratedOn">
              {{ 'PAYMENT_PAGE.PAYMENT_TABLE.DATE' | translate }}
              <p-sortIcon field="GeneratedOn"></p-sortIcon>
            </th>
            <th pSortableColumn="CallerName">
              {{ 'PAYMENT_PAGE.PAYMENT_TABLE.CALLER' | translate }}
              <p-sortIcon field="CallerName"></p-sortIcon>
            </th>
            <th pSortableColumn="TalkingBuddyName">
              {{ 'PAYMENT_PAGE.PAYMENT_TABLE.TALKING_BUDDY' | translate }}
              <p-sortIcon field="TalkingBuddyName"></p-sortIcon>
            </th>
            <th pSortableColumn="TalkingBuddyEarning">
              {{ 'PAYMENT_PAGE.PAYMENT_TABLE.TB_EARNING' | translate }}
              <p-sortIcon field="TalkingBuddyEarning"></p-sortIcon>
            </th>
            <th pSortableColumn="CallDuration">
              {{ 'PAYMENT_PAGE.PAYMENT_TABLE.DURATION' | translate }}
              <p-sortIcon field="CallDuration"></p-sortIcon>
            </th>
            <th pSortableColumn="TotalAmount">
              {{ 'PAYMENT_PAGE.PAYMENT_TABLE.CALL_COST' | translate }}
              <p-sortIcon field="TotalAmount"></p-sortIcon>
            </th>
            <th
              (click)="rotateInvoiceStatusSort(); $event.stopPropagation()"
              class="table-head"
              pSortableColumn="InvoiceStatus"
            >
              {{ 'PAYMENT_PAGE.PAYMENT_TABLE.INVOICE_STATUS' | translate }}
              <p-sortIcon field="InvoiceStatus"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-payment>
          <tr
            *ngIf="paymentItems?.length !== 0"
            (click)="openInvoicePopup(payment.id)"
            class="user-row"
          >
            <td>{{ payment.invoiceNumber }}</td>
            <td>
              {{
                payment?.generatedOn
                  ? (getConvertedDate(payment.generatedOn || '') | date: 'dd-MMM-YYYY')
                  : ''
              }}
            </td>
            <td>{{ payment.callDetails.callerName }}</td>
            <td>{{ payment.callDetails.talkingBuddyName }}</td>
            <td>{{ payment.talkingBuddyEarning | currency: payment.currency }}</td>
            <td class="text-primary">{{ payment.callDetails.callDuration }}</td>
            <td class="text-primary">
              {{ payment.totalAmount | currency: payment.currency }}
            </td>
            <td>
              <span
                class="badge"
                [ngClass]="{
                  'status-success': payment.invoiceStatus === statuses.PAID,
                  'status-danger': payment.invoiceStatus === statuses.FAILED,
                  'status-warning': payment.invoiceStatus === statuses.PENDING,
                  'status-primary': payment.invoiceStatus === statuses.REFUNDED,
                }"
              >
                {{ payment.invoiceStatus }}
              </span>
            </td>
          </tr>
          <tr *ngIf="paymentItems?.length === 0">
            <td colspan="8" class="no-data-available">
              {{ 'COMMON.NO_AVAILABLE' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<app-invoice-popup
  [showInvoicePopup]="showInvoicePopup"
  [invoiceId]="selectedInvoiceId"
  (closePopup)="closePopup()"
></app-invoice-popup>
